import axios from 'axios';

// For private api routes in order to apply a 401 (unauthorized) interceptor
const axiosAuthorized = axios.create({
  withCredentials: true,
  headers: {},
});

export default axiosAuthorized;
